<template>
    <div class="py-12">
        <inertia-link :href="route('kiosk.changelog.index')">
            <AtomicButton color="yellow" size="sm">
                {{ $t("vue.back_to_changelog") }}
                <template #icon>
                    <BackspaceIcon
                        class="mr-2 h-6 w-6 transition duration-200 group-hover:text-gray-600"
                    />
                </template>
            </AtomicButton>
        </inertia-link>

        <h1
            class="mb-6 mt-2 text-2xl font-medium leading-normal tracking-small text-gray-800"
        >
            {{ $t("vue.create_new_changelog_entry") }}
        </h1>

        <ChangelogEntryForm
            :submit-label="$t('vue.save')"
            :processing="loading"
            :errors="errors"
            @submit="save"
        />
    </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { BackspaceIcon } from "@heroicons/vue/24/outline";
import route from "ziggy-js";
import { router } from "@inertiajs/vue3";
import ChangelogEntryForm from "@/Pages/Kiosk/Changelog/components/ChangelogEntryForm.vue";
import type IInputErrors from "@/types/Atomic/IInputErrors";

const loading = ref(false);
const errors = ref<IInputErrors>({});

const save = (payload: Record<string, unknown>) => {
    loading.value = true;
    router.post(route("kiosk.changelog.store"), payload, {
        preserveScroll: false,
        onError: (err) => {
            errors.value = err;
        },
        onSuccess: () => {
            errors.value = {};
        },
        onFinish: () => {
            loading.value = false;
        },
    });
};
</script>
